import React, { useState, useEffect } from "react"
import Img from "gatsby-image"
import { Link } from "gatsby"

const PressReleasesGrid = ({ pressReleases }) => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768)
    }

    checkMobile()
    window.addEventListener("resize", checkMobile)

    return () => window.removeEventListener("resize", checkMobile)
  }, [])

  if (!pressReleases || pressReleases.length === 0) {
    return null
  }

  const sortedReleases = [...pressReleases].sort((a, b) => {
    const dateA = a.acf?.published_date || a.date
    const dateB = b.acf?.published_date || b.date

    const parseDate = dateStr => {
      if (!dateStr) return new Date(0)
      if (typeof dateStr === "string" && dateStr.includes("/")) {
        const [day, month, year] = dateStr.split("/")
        return new Date(`${year}-${month}-${day}`)
      }
      return new Date(dateStr)
    }

    return parseDate(dateB) - parseDate(dateA)
  })

  return (
    <div className="press-releases-grid">
      <div className="press-releases-container container">
        {sortedReleases.map((release, index) => {
          const slug = release.acf?.slug
          const isFeatured =
            sortedReleases.length % 2 !== 0 && index === 0 && !isMobile

          const imageData =
            isMobile && release.acf?.heroImageMobile
              ? release.acf.heroImageMobile
              : release.acf?.heroImageDesktop

          const hasFluidImage =
            imageData?.localFile?.childImageSharp?.fluid &&
            imageData.localFile.childImageSharp.fluid

          const mockImageUrl =
            isMobile && release.imageUrlMobile
              ? release.imageUrlMobile
              : release.imageUrl

          return (
            <Link
              key={release.id || index}
              to={slug ? `/press/${slug}` : "#"}
              className={`press-release-card${
                isFeatured ? " press-release-card--featured" : ""
              }`}
              style={{ textDecoration: "none" }}
            >
              <div className="press-card-header">
                {hasFluidImage ? (
                  <Img
                    fluid={imageData.localFile.childImageSharp.fluid}
                    alt={release.title}
                    className="press-card-image"
                    backgroundColor="transparent"
                  />
                ) : mockImageUrl ? (
                  <img
                    src={mockImageUrl}
                    alt={release.title}
                    className="press-card-image"
                  />
                ) : null}
              </div>

              <div className="press-card-divider"></div>

              <div className="press-card-content">
                <h3 className="press-card-title has-text-weight-semibold">
                  {release.acf?.title
                    ? release.acf.title.replace(/<[^>]*>/g, "")
                    : release.title
                    ? release.title.replace(/<[^>]*>/g, "")
                    : "No title available"}
                </h3>

                <p className="press-card-description has-text-weight-light has-text-purple">
                  {release.acf?.summary || "No summary available"}
                </p>

                <div className="press-card-date has-text-weight-light has-text-purple">
                  {(() => {
                    const dateStr = release.acf?.published_date || release.date
                    if (!dateStr) return "No date available"

                    // Handle DD/MM/YYYY format
                    let date
                    if (typeof dateStr === "string" && dateStr.includes("/")) {
                      const parts = dateStr.split("/")
                      if (parts.length === 3) {
                        // Convert DD/MM/YYYY to MM/DD/YYYY for Date constructor
                        const [day, month, year] = parts
                        date = new Date(`${month}/${day}/${year}`)
                      } else {
                        date = new Date(dateStr)
                      }
                    } else {
                      date = new Date(dateStr)
                    }

                    if (isNaN(date.getTime())) {
                      console.warn("Invalid date:", dateStr)
                      return "Invalid date"
                    }

                    return date.toLocaleDateString("en-US", {
                      month: "short",
                      day: "numeric",
                      year: "numeric",
                    })
                  })()}
                </div>
              </div>
            </Link>
          )
        })}
      </div>
    </div>
  )
}

export default PressReleasesGrid
